import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrivPortal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 44,
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 44,
			height: 44,
			rx: 8,
			fill: "#0DAAF4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 36,
			height: 36,
			rx: 5,
			fill: "#FAFFFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 22.6666C21.8232 22.6666 21.6536 22.7368 21.5286 22.8618C21.4036 22.9869 21.3334 23.1564 21.3334 23.3333V25.3333C21.3334 25.5101 21.4036 25.6796 21.5286 25.8047C21.6536 25.9297 21.8232 25.9999 22 25.9999C22.1768 25.9999 22.3464 25.9297 22.4714 25.8047C22.5964 25.6796 22.6667 25.5101 22.6667 25.3333V23.3333C22.6667 23.1564 22.5964 22.9869 22.4714 22.8618C22.3464 22.7368 22.1768 22.6666 22 22.6666ZM25.3334 19.9999V18.6666C25.3334 17.7825 24.9822 16.9347 24.357 16.3096C23.7319 15.6844 22.8841 15.3333 22 15.3333C21.116 15.3333 20.2681 15.6844 19.643 16.3096C19.0179 16.9347 18.6667 17.7825 18.6667 18.6666V19.9999C18.1363 19.9999 17.6275 20.2106 17.2525 20.5857C16.8774 20.9608 16.6667 21.4695 16.6667 21.9999V26.6666C16.6667 27.197 16.8774 27.7057 17.2525 28.0808C17.6275 28.4559 18.1363 28.6666 18.6667 28.6666H25.3334C25.8638 28.6666 26.3725 28.4559 26.7476 28.0808C27.1226 27.7057 27.3334 27.197 27.3334 26.6666V21.9999C27.3334 21.4695 27.1226 20.9608 26.7476 20.5857C26.3725 20.2106 25.8638 19.9999 25.3334 19.9999ZM20 18.6666C20 18.1362 20.2107 17.6274 20.5858 17.2524C20.9609 16.8773 21.4696 16.6666 22 16.6666C22.5305 16.6666 23.0392 16.8773 23.4142 17.2524C23.7893 17.6274 24 18.1362 24 18.6666V19.9999H20V18.6666ZM26 26.6666C26 26.8434 25.9298 27.013 25.8048 27.138C25.6797 27.263 25.5102 27.3333 25.3334 27.3333H18.6667C18.4899 27.3333 18.3203 27.263 18.1953 27.138C18.0703 27.013 18 26.8434 18 26.6666V21.9999C18 21.8231 18.0703 21.6535 18.1953 21.5285C18.3203 21.4035 18.4899 21.3333 18.6667 21.3333H25.3334C25.5102 21.3333 25.6797 21.4035 25.8048 21.5285C25.9298 21.6535 26 21.8231 26 21.9999V26.6666Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 13,
			width: 18,
			height: 18,
			rx: 2,
			stroke: "black",
			strokeWidth: 2
		})
	]
});
export default SvgPrivPortal;
